import React from "react";
import "./Order_details_table.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Table, Form } from "react-bootstrap";
import { encodeId, variant_type, getVariantImage } from "../../../../utils/common";
import { Link } from "react-router-dom";

function Order_details_table_cancel({
  order,
  selectedItems,
  setSelectedItems,
  setError,
  setProductId,
  setShowReviewRating,
  showReviewRating,
}) {
  const handleCheckboxChange = (val) => {
    setError("");
    setSelectedItems((prev) => {
      const exists = prev.some((item) => item.id === val.id);
      if (exists) {
        return prev.filter((item) => item.id !== val.id);
      } else {
        return [...prev, val];
      }
    });
  };

  const handleOpenReview = async (productDetail) => {
    await setProductId(productDetail?.product_id);
    await setShowReviewRating(true);
  };

  console.log(order, "order orderttttttttttttt");

  return (
    <>
     <section className="Order_details_table Cart_Products_card d-none d-lg-block">
            <div className="inner_box_div">
           
                <div className="row align-items-center inner_card">
                  <div className="col-sm-8 ">
                    <Link
                      to={`/product-details/${encodeId(order?.Product?.id)}`}
                      className="text-decoration-none text-dark"
                    >
                      <div className="row">
                        <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-3 col-3">
                          <div className="img_holder">
                            <img
                              className="Product_img"
                              src={
                                getVariantImage(order)
                              }
                              alt="Product_img"
                            />
                          </div>
                        </div>
    
                        <div className="col-xxl-10 col-xl-9 col-lg-9 col-md-9 col-9">
                          <div className="info_text_holder">
                            <div>
                              <h4>{order?.Product?.name}</h4>
                              <div className="new">
                                {order?.Product?.variant_type_id ===
                                  variant_type.Single && (
                                  <>
                                    {/* <>Variant :</>{" "} */}
                                    <>
                                      <strong>
                                        {order?.Product?.variant_name} :{" "}
                                      </strong>
                                    </>{" "}
                                    {order?.Product_Variant?.Metal?.name}
                                  </>
                                )}
    
                                {order?.Product?.variant_type_id ===
                                  variant_type.Double && (
                                  <>
                                    {/* <>Variant :</>{" "} */}
                                    <>
                                      <strong>
                                        {order?.Product?.variant_name} :
                                      </strong>
                                    </>{" "}
                                    {
                                      order?.Double_Variant?.Product_Variant?.Metal
                                        ?.name
                                    }
                                    <br></br>
                                    <strong>Size :</strong>{" "}
                                    {order?.Double_Variant?.Size?.name}{" "}
                                  </>
                                )}
    
                                {order?.Product?.variant_type_id ===
                                  variant_type.Triple && (
                                  <>
                                    {/* <>Variant :</>{" "} */}
                                    <>
                                      <strong>
                                        {order?.Product?.variant_name} :
                                      </strong>
                                    </>{" "}
                                    {
                                      order?.Triple_Variant?.Double_Variant
                                        ?.Product_Variant?.Metal?.name
                                    }
                                    <br></br>
                                    <strong>Size:</strong>{" "}
                                    {
                                      order?.Triple_Variant?.Double_Variant?.Size
                                        ?.name
                                    }
                                    , <strong>Diamond:</strong>{" "}
                                    {order?.Triple_Variant?.Diamond?.name}
                                  </>
                                )}
                              </div>
    
                              {order?.Product_Variant?.name && (
                                <p className="mb-1">
                                  <strong>Polish :</strong>{" "}
                                  {order?.Product_Variant?.name}
                                </p>
                              )}
    
                              {order?.Double_Variant?.name && (
                                <p className="mb-1">
                                  <strong>Colour :</strong>{" "}
                                  {order?.Double_Variant?.name}
                                </p>
                              )}
    
                              {order?.Triple_Variant?.name && (
                                <p className="mb-1">
                                  <strong>Size :</strong>{" "}
                                  {order?.Triple_Variant?.name}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
    
                   
                  </div>
    
                  <div className="col-sm-4 ">
                    <div className="new_price_holder">
                      <div className="price_inner_text">
                        <p className="right_label">Price </p>
                        <p className="colon_text">:</p>₹{order?.selling_price}
                      </div>
    
                      <div className="price_inner_text">
                        <p className="right_label">Order Qty </p>
                        <p className="colon_text">:</p>{order?.quantity}
                      </div>
    
                      <div className="price_inner_text">
                        <p className="right_label">Total Price </p>
                        <p className="colon_text">:</p>₹{" "}
                        {order?.quantity * order?.selling_price}
                      </div>
                    </div>
                  </div>
                </div>
          
            </div>
          </section>
    
          <div className="d-block d-lg-none mobile_view_holder">
        
              <div className="mobile_product_card" key={order?.id}>
                <Link
                  href={`/product-details/${order?.Product?.id}`}
                  className="text-decoration-none text-dark"
                >
                  <div className="order_holder">
                    <div className="order_holder_left">
                      <div className="img_holder">
                        <img
                          className="Product_img"
                          src={getVariantImage(order)}
                          alt={order?.Product?.name}
                        />
                      </div>
                    </div>
    
                    <div className="order_holder_right">
                      <div className="descn_holder">
                        <div className="left_div">
                          <h6 className="product_name mb-2">
                            {order?.Product?.name}
                          </h6>
    
                          <div className="new">
                            {order?.Product?.variant_type_id ===
                              variant_type.Single && (
                              <>
                                {/* <>Variant :</>{" "} */}
                                <>
                                  <strong>{order?.Product?.variant_name} : </strong>
                                </>{" "}
                                {order?.Product_Variant?.Metal?.name}
                              </>
                            )}
    
                            {order?.Product?.variant_type_id ===
                              variant_type.Double && (
                              <>
                                {/* <>Variant :</>{" "} */}
                                <>
                                  <strong>{order?.Product?.variant_name} :</strong>
                                </>{" "}
                                {order?.Double_Variant?.Product_Variant?.Metal?.name}
                                <br></br>
                                <strong>Size :</strong>{" "}
                                {order?.Double_Variant?.Size?.name}{" "}
                              </>
                            )}
    
                            {order?.Product?.variant_type_id ===
                              variant_type.Triple && (
                              <>
                                {/* <>Variant :</>{" "} */}
                                <>
                                  <strong>{order?.Product?.variant_name} :</strong>
                                </>{" "}
                                {
                                  order?.Triple_Variant?.Double_Variant
                                    ?.Product_Variant?.Metal?.name
                                }
                                <br></br>
                                <strong>Size:</strong>{" "}
                                {order?.Triple_Variant?.Double_Variant?.Size?.name},{" "}
                                <strong>Diamond:</strong>{" "}
                                {order?.Triple_Variant?.Diamond?.name}
                              </>
                            )}
                          </div>
    
                          {order?.Product_Variant?.name && (
                            <p className="mb-1">
                              <strong>Polish :</strong> {order?.Product_Variant?.name}
                            </p>
                          )}
    
                          {order?.Double_Variant?.name && (
                            <p className="mb-1">
                              <strong>Colour :</strong> {order?.Double_Variant?.name}
                            </p>
                          )}
    
                          {order?.Triple_Variant?.name && (
                            <p className="mb-1">
                              <strong>Size :</strong> {order?.Triple_Variant?.name}
                            </p>
                          )}
                        </div>
    
                        <div className="price_details">
                          <p className="mb-1">
                            <strong>₹{order?.selling_price}</strong> X {order?.quantity}
                          </p>
    
                          {/* <p className="mb-1">
                            <strong>Order Qty :</strong> {order?.quantity}
                          </p> */}
    
                          {/* <p className="mb-0">
                            <strong>Total Price :</strong> ₹
                            {order?.quantity * order?.selling_price}
                          </p> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
    
             
              </div>
     
          </div>
    </>
  );
}

export default Order_details_table_cancel;
